import cookie from 'react-cookies';

import Cookies from '@r1-frontend/shared/helpers/Cookies';
import { ACCESS_TOKEN_COOKIE } from '@r1-frontend/shared/helpers/getAccessToken';
import { isServerSide } from '@r1-frontend/shared/helpers/ssr';

import { COOKIE_MAX_AGE_LONG } from '~/src/constants';

/**
 * Кука хранит часть ACCESS_TOKEN, для определения нового входа пользователя
 */
const LAST_ENTER_COOKIE = 'lastEnter';
const MAX_LENGTH_VALUE = 10;

/**
 * Возвращает true - если пользователь только что залогинился, false - для последующих переходов по сайту
 * сравнивает хвост ACCESS_TOKEN, хранит его в куке LAST_ENTER
 */
export const checkNewEnter = () => {
    if (isServerSide()) {
        return false;
    }

    const cookies = new Cookies();

    const lastEnter = cookie.load(LAST_ENTER_COOKIE);
    const accessToken = cookie.load(ACCESS_TOKEN_COOKIE);
    const partAccessToken = accessToken.substring(accessToken.length - MAX_LENGTH_VALUE, accessToken.length);

    if (partAccessToken === lastEnter) {
        return false;
    }

    cookies.save({
        name: LAST_ENTER_COOKIE,
        value: partAccessToken,
        config: { maxAge: COOKIE_MAX_AGE_LONG },
    });

    return true;
};
